let language = {
    "A113B001": "There is no tax rate for this order, so we couldn't determine the pricing. Please visit the related page and provide this information. Thank you.",
    "A113B002": "There is no tax rate for this order, so we couldn't determine the pricing. Please visit the related page and provide this information. Thank you.",

    "A113B003":"The current order does not match the logged-in partner account.",
    "A113B004":"The current order does not belong to partner account you are logged into. Please check your account or log in with the correct credentials.",

    "A113B005":"Opps, Unsupported group order type, only retail orders are supported",
    "A113B006":"Unsupported group order type, only retail orders are supported",
    
    "A113B007":"Wrong weight unit",
    "A113B008":"Wrong weight unit",
    
    "A113B009":"This order is missing when trying to combine it with other orders. You can retry and refresh the page. If the issue persists, please contact our technical team at {{supportmail}}",
    "A113B010":"This order is missing when trying to combine it with other orders. You can retry and refresh the page. If the issue persists, please contact our technical team at {{supportmail}}",
    
    "A113B011":"There is an error with the provided shipping address, particularly the postcode, which does not match the selected shipping country/region. Please check it and try again",
    "A113B012":"There is an error with the provided shipping address, particularly the postcode, which does not match the selected shipping country/region. Please check it and try again",
    
    "A113B013":"Failed to retrieve the product pricing table",
    "A113B014":"Sorry, something went wrong, and we can't retrieve the pricing table for your request. Please contact our technical team for assistance at {{supportmail}}",
    
    "A113B015":"The information is empty or the required data is illegal",
    "A113B016":"The information is empty or the required data is illegal",
    
    "A113B017":"Failed to get shipping cost.",
    "A113B018":"We couldn't retrieve the shipping cost. Please check your input and try again. If the issue persists, contact us with the current URL containing your store ID and product ID.",
    
    "A113B019":"The current order has already been combined.",
    "A113B020":"The current order has already been combined.",
    
    "A113B021":"The current order seems like does Not Belong to Current Partner",
    "A113B022":"The current order does not appear to belong to the current partner. For more information, please contact {{supportmail}} to resolve the issue.",
    
    "A113B023":"The partner ID does not exist",
    "A113B024":"The partner ID does not exist",
    
    "A113B025":"The selected delivery method for this order is not supported.",
    "A113B026":"You can select another available delivery option on our website",
    
    "A113B027":"Missing Parameters in URL",
    "A113B028":"The URL is incomplete. Please check if for accuracy, then resubmit and refresh the page.",
    
    "A113B029":"The group order is automatically grouped but no ordering user is specified",
    "A113B030":"The group order is automatically grouped but no ordering user is specified",
    
    "A113B031": "The following countrys/regions does not support delivery: \n{{region}}.",
    "A113B032": "The following countrys/regions does not support delivery: \n{{region}}.",
    
    "A113B033": "The store retail order item does not exist: \n{{notExistOrderItemIds}}.",
    "A113B034": "The customer order does not exist and cannot be combined: \n{{notExistOrderIds}}.",
    "A113B035": "The store does not exist: \n{{notExistStoreIds}}.",
    
    BULK_ORDER_CHECKOUT_CALC_PRICE_FAIL_TITLE: "Calculate price failed",
    BULK_ORDER_CHECKOUT_CURRENCY_ERROE_TITLE:"Combine Order Error",
    BULK_ORDER_CHECKOUT_CURRENCY_CONFIG_MISSING_CONTENT:"There is an error with the {{appName}} currency setting. Please refresh the page and click \"{{updateCurrencyBtn}}\" to update {{appName}} display currency. If issues still persist, please contact {{serviceEmail}}",
    BULK_ORDER_CHECKOUT_CURRENCY_NONSUPPORT_CONTENT:"The currency you selected is not supported. Please click \"{{updateCurrencyBtn}}\" to update {{appName}} display currency.",
    A113B3000601: "The current currency: {{currentCurrency}}, supported currency types on the {{appName}} platform: {{supportCurrencies}}",
    A113B300310: "The currency {{currentCurrency}} does not exist in the system.",
    
    BULK_ORDER_CHECKOUT_EXIST_NOT_BELONG_USER_ITEM_TITLE: "Combine Order Error",
    BULK_ORDER_CHECKOUT_EXIST_NOT_BELONG_USER_ITEM_CONTENT: "Exist not belong logined user bulkableItem",

    BULK_ORDER_LIST_INFO_TIPS_TITLE_STORE:'Order Mismatch',
    BULK_ORDER_STORE_INFO_TIPS_TITLE:'Invalid partner account',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_TAX_CONFIG:'Tax rate is missing',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_INVALID_ORDER:"The current order was not found",
    BULK_ORDER_LIST_INFO_TIPS_TITLE_INVALID_STORE_ORDER: 'Invalid store order',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_INVALID_ADDRESS:'Invalid shipping address information',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_INVALID_PRICING:'Error in Shipping Cost Calculation',
    BULK_ORDER_CONFIGURATION_INFO_TIPS_TITLE:'Invalid configuration',
    BULK_ORDER_CONFIGURATION_INFO_TIPS_TITLE_INVALID_USER:'Order Mismatch Partner store',
    BULK_ORDER_CODE_INFO_TIPS_TITLE:'The coupon code is invalid',
    BULK_ORDER_LIST_INFO_TIPS_TITLE_PAYMENT_FAILED:"Payment unsuccessful",
    BULK_ORDER_LIST_INFO_TIPS_TITLE_PAYMENT_FAILED_DES1:"We currently do not support this payment method. Please choose another payment option and try again, or you can contact our technical support at {{supportmail}} to fix this problem.",
    BULK_ORDER_CREATE_ORDER_ISSUE_TITLE:"Create Order Issue",
    BULK_ORDER_CREATE_ORDER_BY_CURRENCY_ISSUE_CONTENT:"Currency Type Changed. Please review your order information and proceed with placing your order again.",
    BULK_ORDER_PAGE_INIT_ISSUE_TITLE:"Page Loading Issue",
    BULK_ORDER_PAGE_INIT_ISSUE_CONTENT:"An issue occurred while loading this page. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    A113B036: "Error Retrieving User Currency Preference Settings.",

    // 300523:"店铺id: {storeIds}  不属于当前登录用户！",
    // 300591:"不支持的拼单类型,仅支持零售订单",
    // 300593:"可拼单项为空",
    // 300584:"计算价格Price为空",
    // 300585:"不合法的价格信息",
    // 300586:"价格信息的金额数值为空！",
    // 300587:"货币信息为空！",
    // 300588:"货币信息的货币代码为空！",
    // 300589:"不支持货币代码：{code} !",

    // 300518:"下单item为空,空id数组",
    // 300519:"下单零售订单id为空",
    // 300590:"计重单位错误",
    // 1500013:"稅地址校验失败",
    // 1500014:"地址校驗超時",
    // 1500015:"地址校验失败",
    // 1500016:"地址校验失败",
    
    // 300583:"匿名用户网站代码不能为空！",
    // 300581:"user绑定的website不存在",
    // 3005822:"订单项已经拼单",
    // 300517:"不支持此运输方式",
    // 400600:"拼单下单为自动拼单但是未指定下单用户",
    // 400506:"user不属于任何partner",
    
    // 712313: "配送地址国家处于黑名单中"
    
    // 310535 StoreRetailOrderItem:{notExistOrderItemIds} not exist! （店铺零售订单项不存在）
    // 310536 StoreRetailOrder:{notExistOrderIds} not exist! *（店铺零售订单不存在）
    // 310537 store:{notExistStoreIds} not exist! （店铺不存在）
    
    // 300524 存在不属于当前用户可拼单项
};

export { language }